/*
 * CourseKit — одна платформа на все курсы рубрики «Курсы».
 *
 * Страница (компонент <x-course>) уже нарисовала программу: этапы и уроки
 * с теми же классами, что рисует этот файл. Здесь — только жизнь:
 *   • прогресс (localStorage, на устройстве), серия дней, звёзды уроков;
 *   • проигрыватель урока: шаги по одному, одна главная кнопка, разбор
 *     после ответа, ошибка возвращается в конце урока ещё раз;
 *   • повторение по интервалам: ошибка → коробка 1 (завтра) → 3 → 7 → 14 → 30 дней;
 *   • экзамен этапа с порогом сдачи и списком уроков, которые стоит повторить;
 *   • стена Премиума: закрытый урок сервер отдаёт только Премиуму (403 → стена);
 *   • сертификат PDF, когда пройдено всё.
 *
 * Типы шагов регистрируются снаружи: CourseKit.step(type, impl) — общие в
 * course-steps.js, доменные (доска, микрофон, клавиатура) — в файле курса.
 * Контракт — docs/courses.md.
 */
(function () {
    'use strict';

    var CFG = window.__COURSE || null;
    var T = (CFG && CFG.T) || {};
    var TT = (CFG && CFG.TT) || {};
    var types = {};
    var figures = {};
    var lessonCache = {};
    var root, mapEl, runEl, headEl, reviewEl, certEl, liveEl;
    var current = null; // текущий прогон урока

    /* ── мелочи ─────────────────────────────────────────────────────── */

    function fmt(s, rep) {
        s = s == null ? '' : String(s);
        if (!rep) return s;
        return s.replace(/:([a-z_]+)/g, function (m, k) {
            return Object.prototype.hasOwnProperty.call(rep, k) ? String(rep[k]) : m;
        });
    }
    function t(k, rep) { return fmt(T[k] != null ? T[k] : k, rep); }
    function tt(k, rep) { return fmt(TT[k] != null ? TT[k] : (T[k] != null ? T[k] : k), rep); }

    function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text != null) e.textContent = text;
        return e;
    }
    function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }
    /* Разметка в текстах курса — только **жирный**, *курсив* и перевод строки. */
    function rich(s) {
        return esc(s)
            .replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>')
            .replace(/(^|[^*])\*([^*\s][^*]*)\*(?!\*)/g, '$1<i>$2</i>')
            .replace(/\n/g, '<br>');
    }
    function richEl(tag, cls, s) {
        var e = el(tag, cls);
        e.innerHTML = rich(s);
        return e;
    }
    /* Тело теории: строки «## …» — подзаголовок, «- …» — пункт списка. */
    function body(host, lines) {
        if (!lines || !lines.length) return null;
        var box = el('div', 'crs-body');
        var ul = null;
        lines.forEach(function (line) {
            line = String(line);
            if (/^- /.test(line)) {
                if (!ul) { ul = el('ul'); box.appendChild(ul); }
                ul.appendChild(richEl('li', null, line.slice(2)));
                return;
            }
            ul = null;
            if (/^## /.test(line)) box.appendChild(richEl('h4', null, line.slice(3)));
            else box.appendChild(richEl('p', null, line));
        });
        host.appendChild(box);
        return box;
    }
    function shuffle(a) {
        a = a.slice();
        for (var i = a.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var x = a[i]; a[i] = a[j]; a[j] = x;
        }
        return a;
    }
    /* Перемешать так, чтобы порядок не совпал с исходным (если это возможно). */
    function shuffleApart(a) {
        if (a.length < 2) return a.slice();
        for (var k = 0; k < 8; k++) {
            var s = shuffle(a);
            for (var i = 0; i < s.length; i++) if (s[i] !== a[i]) return s;
        }
        return a.slice(1).concat(a[0]);
    }
    function today() {
        var d = new Date();
        return Math.floor((d.getTime() - d.getTimezoneOffset() * 60000) / 86400000);
    }
    function announce(msg) {
        try { if (window.__announce) { window.__announce(msg); return; } } catch (_) {}
        if (liveEl) { liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 30); }
    }
    function ae(name, data) {
        try { if (window.__ae) window.__ae(name, Object.assign({ course: CFG.slug }, data || {})); } catch (_) {}
    }
    function stage(name, data) {
        try { if (window.__stage) window.__stage(name, data || {}); } catch (_) {}
    }
    function pct(x) { return Math.round(Math.max(0, Math.min(1, x)) * 100); }
    function numFmt(n) {
        try { return new Intl.NumberFormat(window.__intlLocale ? window.__intlLocale() : undefined).format(n); } catch (_) { return String(n); }
    }

    /* ── прогресс на устройстве ─────────────────────────────────────── */

    var BOX_DAYS = [0, 1, 3, 7, 14, 30];
    var Store = {
        d: null,
        key: function () { return 'tmb_course_v1:' + CFG.slug; },
        load: function () {
            var d = null;
            try { d = JSON.parse(localStorage.getItem(this.key()) || 'null'); } catch (_) { d = null; }
            if (!d || typeof d !== 'object') d = {};
            d.lessons = d.lessons || {};
            d.review = d.review || {};
            d.days = Array.isArray(d.days) ? d.days : [];
            d.kv = d.kv || {};
            this.d = d;
            return d;
        },
        save: function () {
            try { localStorage.setItem(this.key(), JSON.stringify(this.d)); } catch (_) {}
        },
        lesson: function (id) { return this.d.lessons[id] || null; },
        isDone: function (id) { var l = this.d.lessons[id]; return !!(l && l.done); },
        markDay: function () {
            var n = today();
            if (this.d.days.indexOf(n) < 0) {
                this.d.days.push(n);
                if (this.d.days.length > 120) this.d.days = this.d.days.slice(-120);
            }
        },
        streak: function () {
            var set = {};
            this.d.days.forEach(function (x) { set[x] = 1; });
            var n = today(), s = 0;
            if (!set[n]) n -= 1; // сегодня ещё не занимались — серия жива до вечера
            while (set[n]) { s++; n--; }
            return s;
        },
        finish: function (id, score, done) {
            var l = this.d.lessons[id] || { tries: 0, best: 0, done: false };
            l.tries = (l.tries || 0) + 1;
            l.best = Math.max(l.best || 0, score);
            l.done = l.done || !!done;
            l.at = Date.now();
            this.d.lessons[id] = l;
            this.markDay();
            this.save();
        },
        miss: function (lessonId, stepId) {
            var k = lessonId + '/' + stepId;
            this.d.review[k] = { l: lessonId, s: stepId, box: 1, due: today() + 1 };
            this.save();
        },
        reviewed: function (lessonId, stepId, ok) {
            var k = lessonId + '/' + stepId;
            var r = this.d.review[k];
            if (!r) { if (!ok) this.miss(lessonId, stepId); return; }
            if (ok) {
                r.box = (r.box || 1) + 1;
                if (r.box >= BOX_DAYS.length) { delete this.d.review[k]; this.save(); return; }
                r.due = today() + BOX_DAYS[r.box];
            } else {
                r.box = 1;
                r.due = today() + 1;
            }
            this.save();
        },
        due: function () {
            var n = today(), out = [];
            for (var k in this.d.review) {
                if (Object.prototype.hasOwnProperty.call(this.d.review, k) && this.d.review[k].due <= n) out.push(this.d.review[k]);
            }
            out.sort(function (a, b) { return a.due - b.due || a.box - b.box; });
            return out;
        },
        kvGet: function (k, def) { return Object.prototype.hasOwnProperty.call(this.d.kv, k) ? this.d.kv[k] : def; },
        kvSet: function (k, v) { this.d.kv[k] = v; this.save(); },
        reset: function () {
            this.d = { lessons: {}, review: {}, days: [], kv: {} };
            this.save();
        }
    };

    /* ── программа ──────────────────────────────────────────────────── */

    var flat = [];
    function buildFlat() {
        flat = [];
        (CFG.outline.stages || []).forEach(function (st, si) {
            (st.lessons || []).forEach(function (l) {
                flat.push(Object.assign({ stageIndex: si, stageId: st.id, stageTitle: st.title }, l));
            });
        });
    }
    function meta(id) {
        for (var i = 0; i < flat.length; i++) if (flat[i].id === id) return flat[i];
        return null;
    }
    function canOpen(m) { return !!(m && (m.open || CFG.premium)); }
    function nextUndone() {
        for (var i = 0; i < flat.length; i++) if (!Store.isDone(flat[i].id)) return flat[i];
        return null;
    }
    function doneCount() {
        var n = 0;
        flat.forEach(function (m) { if (Store.isDone(m.id)) n++; });
        return n;
    }
    function allDone() { return flat.length > 0 && doneCount() === flat.length; }

    function loadLesson(id) {
        if (lessonCache[id]) return Promise.resolve(lessonCache[id]);
        var pre = (CFG.open || []).filter(function (l) { return l.id === id; })[0];
        if (pre) { lessonCache[id] = pre; return Promise.resolve(pre); }
        var url = CFG.api.replace('__L__', encodeURIComponent(id)) + '?l=' + encodeURIComponent(CFG.locale);
        var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
        var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 20000);
        return fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
            .then(function (r) {
                clearTimeout(timer);
                if (r.status === 403) { var e = new Error('locked'); e.locked = true; throw e; }
                if (!r.ok) { var e2 = new Error('http ' + r.status); e2.net = true; throw e2; }
                return r.json();
            }, function (err) {
                clearTimeout(timer);
                var e = new Error('network'); e.net = true; e.cause = err; throw e;
            })
            .then(function (j) {
                if (!j || !j.success || !j.lesson) { var e = new Error('bad payload'); e.net = true; throw e; }
                lessonCache[id] = j.lesson;
                return j.lesson;
            });
    }

    /* ── карта ──────────────────────────────────────────────────────── */

    function stars(best) {
        var n = best >= 0.9 ? 3 : best >= 0.7 ? 2 : 1;
        return '★★★'.slice(0, n) + '☆☆☆'.slice(0, 3 - n);
    }

    function refreshMap() {
        var nxt = nextUndone();
        var done = doneCount();
        var ring = document.getElementById('crsRing');
        var ringN = document.getElementById('crsRingN');
        var p = flat.length ? pct(done / flat.length) : 0;
        if (ring) ring.style.setProperty('--p', p);
        if (ringN) ringN.textContent = p + '%';

        var sub = document.getElementById('crsHeadSub');
        if (sub) {
            var line;
            if (allDone()) line = t('head_all_done');
            else if (done === 0) line = CFG.premium ? t('head_premium') : t('head_free', { free: CFG.outline.free, total: CFG.outline.total });
            else line = t('head_progress', { done: done, total: flat.length }) + (nxt ? ' ' + t('head_next', { title: nxt.title }) : '');
            sub.textContent = line;
            var s = Store.streak();
            if (s >= 2) {
                var sp = el('span', 'crs-streak', '🔥 ' + t('streak', { n: s }));
                sub.appendChild(document.createTextNode(' '));
                sub.appendChild(sp);
            }
        }
        var cont = document.getElementById('crsContinue');
        if (cont) cont.textContent = allDone() ? t('again') : (done === 0 ? t('start') : t('continue'));

        var buttons = mapEl.querySelectorAll('.crs-lesson[data-lesson]');
        for (var i = 0; i < buttons.length; i++) {
            var b = buttons[i];
            var id = b.getAttribute('data-lesson');
            var m = meta(id);
            var l = Store.lesson(id);
            b.classList.toggle('is-done', !!(l && l.done));
            b.classList.toggle('is-next', !!(nxt && nxt.id === id));
            b.classList.toggle('is-locked', !canOpen(m));
            var metaBox = b.querySelector('.crs-lesson-meta');
            var st = metaBox && metaBox.querySelector('.crs-stars');
            if (l && l.done && metaBox) {
                if (!st) { st = el('span', 'crs-stars'); metaBox.insertBefore(st, metaBox.firstChild); }
                st.textContent = stars(l.best || 0);
                st.setAttribute('aria-label', t('best_score', { pct: pct(l.best || 0) }));
            } else if (st) { st.remove(); }
            var num = b.querySelector('.crs-lesson-n');
            if (num && m) num.textContent = (l && l.done) ? '✓' : (m.kind === 'exam' ? '★' : String(m.index + 1));
        }
        var stagesEls = mapEl.querySelectorAll('.crs-stage[data-stage]');
        for (var k = 0; k < stagesEls.length; k++) {
            var sid = stagesEls[k].getAttribute('data-stage');
            var all = flat.filter(function (m) { return m.stageId === sid; });
            var dn = all.filter(function (m) { return Store.isDone(m.id); }).length;
            var bar = stagesEls[k].querySelector('.crs-stage-bar span');
            if (bar) bar.style.width = (all.length ? pct(dn / all.length) : 0) + '%';
        }

        var due = Store.due().filter(function (r) { var m = meta(r.l); return canOpen(m); });
        if (reviewEl) {
            reviewEl.hidden = due.length === 0;
            var rt = document.getElementById('crsReviewTx');
            if (rt) rt.textContent = t('review_desc', { n: due.length });
        }
        if (certEl) certEl.hidden = !allDone();
    }

    function showMap() {
        stopCurrent();
        runEl.hidden = true;
        runEl.innerHTML = '';
        mapEl.hidden = false;
        headEl.hidden = false;
        refreshMap();
        try { headEl.scrollIntoView({ block: 'nearest' }); } catch (_) {}
    }

    function showRunShell() {
        stopCurrent();
        mapEl.hidden = true;
        headEl.hidden = true;
        if (reviewEl) reviewEl.hidden = true;
        if (certEl) certEl.hidden = true;
        runEl.hidden = false;
        runEl.innerHTML = '';
    }

    function focusTop() {
        var top = runEl.querySelector('.crs-run-top, .crs-lock, .crs-center, .crs-end');
        if (top) {
            try { top.scrollIntoView({ block: 'nearest' }); } catch (_) {}
        }
    }

    /* ── стена Премиума ─────────────────────────────────────────────── */

    function showLock(m) {
        showRunShell();
        ae('course_lock_view', { lesson: m ? m.id : null });
        var card = el('section', 'lg-card crs-lock');
        card.appendChild(el('div', 'crs-lock-ic', '🔒'));
        card.appendChild(el('h2', 'crs-lock-title', t('lock_title')));
        if (m) card.appendChild(el('p', 'crs-lock-tx', t('lock_lesson', { title: m.title })));
        card.appendChild(el('p', 'crs-lock-tx', t('lock_desc', { free: CFG.outline.free, total: CFG.outline.total })));
        var ul = el('ul', 'crs-lock-list');
        [t('lock_li_program', { stages: (CFG.outline.stages || []).length, total: CFG.outline.total }),
         CFG.exams ? t('lock_li_exams', { n: CFG.exams }) : null,
         t('lock_li_review'),
         t('lock_li_cert')].forEach(function (s) { if (s) ul.appendChild(el('li', null, s)); });
        card.appendChild(ul);
        var acts = el('div', 'crs-acts');
        var cta = el('a', 'lg-btn', t('lock_cta'));
        cta.href = CFG.proUrl;
        cta.addEventListener('click', function () { ae('course_lock_cta', { lesson: m ? m.id : null }); });
        acts.appendChild(cta);
        var back = el('button', 'lg-btn lg-btn-ghost', t('lock_back'));
        back.type = 'button';
        back.addEventListener('click', showMap);
        acts.appendChild(back);
        card.appendChild(acts);
        if (CFG.loginUrl) {
            var lg = el('p', 'crs-hint');
            var a = el('a', null, t('lock_login'));
            a.href = CFG.loginUrl;
            lg.appendChild(a);
            card.appendChild(lg);
        }
        runEl.appendChild(card);
        focusTop();
    }

    function showError(retry) {
        showRunShell();
        var card = el('section', 'lg-card crs-center');
        card.appendChild(el('p', null, t('load_error')));
        var acts = el('div', 'crs-acts');
        acts.style.justifyContent = 'center';
        var b = el('button', 'lg-btn', t('retry')); b.type = 'button'; b.addEventListener('click', retry);
        var bk = el('button', 'lg-btn lg-btn-ghost', t('to_map')); bk.type = 'button'; bk.addEventListener('click', showMap);
        acts.appendChild(b); acts.appendChild(bk);
        card.appendChild(acts);
        runEl.appendChild(card);
        focusTop();
    }

    function showLoading() {
        showRunShell();
        runEl.appendChild(el('section', 'lg-card crs-center', t('loading')));
    }

    /* ── открыть урок ───────────────────────────────────────────────── */

    function openLesson(id) {
        var m = meta(id);
        if (!m) return;
        if (!canOpen(m)) { showLock(m); return; }
        showLoading();
        loadLesson(id).then(function (lesson) {
            run({ mode: m.kind === 'exam' ? 'exam' : 'lesson', lesson: lesson, meta: m, steps: lesson.steps.map(function (s) { return Object.assign({ _lesson: lesson.id }, s); }) });
        }, function (err) {
            if (err && err.locked) { CFG.premium = false; showLock(m); return; }
            showError(function () { openLesson(id); });
        });
    }

    function openReview() {
        var due = Store.due().filter(function (r) { return canOpen(meta(r.l)); }).slice(0, 12);
        if (!due.length) { showMap(); return; }
        showLoading();
        var ids = [];
        due.forEach(function (r) { if (ids.indexOf(r.l) < 0) ids.push(r.l); });
        Promise.all(ids.map(function (id) { return loadLesson(id).catch(function () { return null; }); })).then(function (lessons) {
            var byId = {};
            lessons.forEach(function (l) { if (l) byId[l.id] = l; });
            var steps = [];
            due.forEach(function (r) {
                var l = byId[r.l];
                if (!l) return;
                var s = l.steps.filter(function (x) { return x.id === r.s; })[0];
                if (s && types[s.type] && types[s.type].reviewable !== false && isGradableType(s.type)) {
                    steps.push(Object.assign({ _lesson: l.id }, s));
                } else if (!s) {
                    delete Store.d.review[r.l + '/' + r.s];
                }
            });
            Store.save();
            if (!steps.length) { showMap(); return; }
            run({ mode: 'review', lesson: { id: '_review', title: t('review_title'), steps: steps }, meta: null, steps: shuffle(steps) });
        });
    }

    function isGradableType(type) {
        var impl = types[type];
        return !!(impl && impl.graded !== false);
    }

    /* ── проигрыватель ──────────────────────────────────────────────── */

    function stopCurrent() {
        if (current && current.ctl) {
            try { current.ctl.destroy && current.ctl.destroy(); } catch (_) {}
        }
        if (current) {
            (current.cleanups || []).forEach(function (fn) { try { fn(); } catch (_) {} });
            current.cleanups = [];
            current.dead = true;
        }
        current = null;
    }

    function run(opts) {
        showRunShell();
        var R = {
            mode: opts.mode,
            lesson: opts.lesson,
            meta: opts.meta,
            queue: opts.steps.slice(),
            i: 0,
            graded: 0,
            points: 0,
            misses: [],
            again: {},
            marks: [],
            cleanups: [],
            keyFn: null,
            dead: false
        };
        current = R;
        stage('lesson_open', { lesson: R.lesson.id, mode: R.mode });
        ae('course_lesson_open', { lesson: R.lesson.id, mode: R.mode });

        var top = el('section', 'lg-card');
        var bar1 = el('div', 'crs-run-top');
        var back = el('button', 'lg-btn lg-btn-ghost lg-btn-sm', '← ' + t('to_map'));
        back.type = 'button';
        back.addEventListener('click', function () { ae('course_lesson_leave', { lesson: R.lesson.id, at: R.i }); showMap(); });
        bar1.appendChild(back);
        var title = el('div', 'crs-run-title', R.mode === 'review' ? t('review_title') : R.lesson.title);
        bar1.appendChild(title);
        var count = el('div', 'crs-run-count');
        bar1.appendChild(count);
        top.appendChild(bar1);
        var bar = el('div', 'crs-bar');
        bar.setAttribute('aria-hidden', 'true');
        top.appendChild(bar);
        runEl.appendChild(top);

        var card = el('section', 'lg-card crs-card');
        var host = el('div', 'crs-step');
        var fb = el('div', 'crs-fb');
        fb.hidden = true;
        fb.setAttribute('role', 'status');
        var acts = el('div', 'crs-acts');
        var secondary = el('button', 'lg-btn lg-btn-ghost');
        secondary.type = 'button';
        secondary.hidden = true;
        var grow = el('span', 'crs-grow');
        var primary = el('button', 'lg-btn');
        primary.type = 'button';
        acts.appendChild(secondary);
        acts.appendChild(grow);
        acts.appendChild(primary);
        card.appendChild(host);
        card.appendChild(fb);
        card.appendChild(acts);
        runEl.appendChild(card);
        R.dom = { host: host, fb: fb, primary: primary, secondary: secondary, bar: bar, count: count };

        var primaryFn = null, secondaryFn = null;
        primary.addEventListener('click', function () { if (!primary.disabled && primaryFn) primaryFn(); });
        secondary.addEventListener('click', function () { if (secondaryFn) secondaryFn(); });
        R.setPrimary = function (label, fn, disabled) {
            primaryFn = fn || null;
            primary.textContent = label || t('next');
            primary.disabled = !!disabled;
            primary.hidden = !fn;
        };
        R.setSecondary = function (label, fn) {
            secondaryFn = fn || null;
            secondary.textContent = label || '';
            secondary.hidden = !fn;
        };

        renderBar(R);
        showStep(R);
        focusTop();
    }

    function renderBar(R) {
        var bar = R.dom.bar;
        bar.innerHTML = '';
        for (var i = 0; i < R.queue.length; i++) {
            var seg = el('i');
            if (R.marks[i] === true) seg.className = 'is-ok';
            else if (R.marks[i] === false) seg.className = 'is-bad';
            else if (i === R.i) seg.className = 'is-cur';
            bar.appendChild(seg);
        }
        R.dom.count.textContent = t('step_of', { n: Math.min(R.i + 1, R.queue.length), total: R.queue.length });
    }

    function showStep(R) {
        if (R.dead) return;
        if (R.ctl) { try { R.ctl.destroy && R.ctl.destroy(); } catch (_) {} R.ctl = null; }
        (R.cleanups || []).forEach(function (fn) { try { fn(); } catch (_) {} });
        R.cleanups = [];
        R.keyFn = null;
        R.answered = false;
        R.dom.host.innerHTML = '';
        R.dom.fb.hidden = true;
        R.dom.fb.innerHTML = '';
        R.setSecondary(null, null);
        R.setPrimary(null, null);
        if (R.i >= R.queue.length) { finish(R); return; }
        renderBar(R);
        var step = R.queue[R.i];
        var impl = types[step.type];
        var api = makeApi(R, step);
        if (!impl) {
            R.dom.host.appendChild(el('p', 'crs-hint', t('step_unsupported')));
            R.setPrimary(t('next'), function () { advance(R); });
            return;
        }
        try {
            R.ctl = impl.mount(R.dom.host, step, api) || null;
        } catch (e) {
            try { if (window.__handleError) window.__handleError(e, 'course_step_mount', { say: t('step_failed') }); } catch (_) {}
            R.dom.host.appendChild(el('p', 'crs-hint', t('step_failed')));
            R.setPrimary(t('next'), function () { advance(R); });
        }
    }

    function makeApi(R, step) {
        var api = {
            step: step,
            mode: R.mode,
            exam: R.mode === 'exam',
            locale: CFG.locale,
            slug: CFG.slug,
            t: t,
            tt: tt,
            el: el,
            rich: rich,
            richEl: richEl,
            body: body,
            shuffle: shuffle,
            shuffleApart: shuffleApart,
            announce: announce,
            fmt: fmt,
            num: numFmt,
            figure: function (host, fig) { return renderFigure(host, fig || step.figure, step, api); },
            primary: function (label, fn, disabled) { if (!R.answered) R.setPrimary(label, fn, disabled); },
            primaryEnabled: function (on) { if (!R.answered) R.dom.primary.disabled = !on; },
            secondary: function (label, fn) { R.setSecondary(label, fn); },
            answer: function (res) { answer(R, step, res || {}); },
            next: function () { advance(R); },
            skip: function (note) { answer(R, step, { correct: null, skipped: true, explain: note || null }); },
            onKey: function (fn) { R.keyFn = fn; },
            onCleanup: function (fn) { R.cleanups.push(fn); },
            alive: function () { return current === R && !R.dead; },
            audioCtx: audioCtx,
            tone: function (notes, o) { return CourseKit.audio.notes(notes, o || {}); },
            say: function (text, lang, o) { return CourseKit.audio.say(text, lang, o || {}); },
            mic: function (constraints) {
                return openMic(constraints).then(function (stream) {
                    R.cleanups.push(function () { try { stream.getTracks().forEach(function (tr) { tr.stop(); }); } catch (_) {} });
                    return stream;
                });
            },
            micError: micError,
            store: { get: function (k, d) { return Store.kvGet(k, d); }, set: function (k, v) { Store.kvSet(k, v); } }
        };
        return api;
    }

    /* Ответ шага. res: {correct: true|false|null, score?: 0..1, reveal?: string,
       explain?: string, skipped?: bool}. null — шаг без оценки (теория, практика). */
    function answer(R, step, res) {
        if (R.answered || R.dead) return;
        R.answered = true;
        var graded = res.correct !== null && res.correct !== undefined && !res.skipped;
        var ok = graded ? !!res.correct : null;
        var score = graded ? (typeof res.score === 'number' ? Math.max(0, Math.min(1, res.score)) : (ok ? 1 : 0)) : null;
        var first = !step._again;

        if (graded && first) {
            R.graded++;
            R.points += score;
            R.marks[R.i] = ok;
            if (!ok) R.misses.push({ step: step, reveal: res.reveal || null });
        } else if (graded) {
            R.marks[R.i] = ok;
        }
        if (graded && step._lesson && step._lesson !== '_review') {
            if (R.mode === 'review') Store.reviewed(step._lesson, step.id, ok);
            else if (!ok && first) Store.miss(step._lesson, step.id);
            else if (ok && Store.d.review[step._lesson + '/' + step.id] && first) Store.reviewed(step._lesson, step.id, true);
        }
        var willRepeat = graded && !ok && first && R.mode !== 'exam' && !R.again[step.id];
        if (willRepeat) {
            R.again[step.id] = true;
            R.queue.push(Object.assign({}, step, { _again: true }));
        }

        var fb = R.dom.fb;
        fb.innerHTML = '';
        fb.className = 'crs-fb ' + (ok === true ? 'is-ok' : ok === false ? 'is-bad' : 'is-neutral');
        var showFb = graded || res.explain || res.skipped;
        if (showFb) {
            var head = ok === true ? (score < 1 ? t('fb_partial', { pct: pct(score) }) : t('fb_right'))
                : ok === false ? t('fb_wrong') : (res.skipped ? t('fb_skipped') : t('fb_noted'));
            fb.appendChild(el('p', 'crs-fb-title', head));
            if (ok === false && res.reveal) fb.appendChild(richEl('p', 'crs-fb-tx', t('fb_answer') + ' ' + res.reveal));
            var ex = res.explain != null ? res.explain : (step.t && step.t.explain);
            if (ex) fb.appendChild(richEl('p', 'crs-fb-tx', ex));
            if (willRepeat) fb.appendChild(el('p', 'crs-fb-tx', t('fb_again')));
            fb.hidden = false;
            announce(head);
        }
        renderBar(R);
        var last = R.i >= R.queue.length - 1;
        R.setSecondary(null, null);
        R.setPrimary(last ? t('finish') : t('next'), function () { advance(R); });
        try { R.dom.primary.focus({ preventScroll: true }); } catch (_) {}
        if (!showFb) advance(R);
    }

    function advance(R) {
        if (R.dead) return;
        R.i++;
        showStep(R);
        var host = R.dom.host;
        try { (host.closest('.crs-card') || host).scrollIntoView({ block: 'nearest' }); } catch (_) {}
    }

    function finish(R) {
        var score = R.graded ? R.points / R.graded : 1;
        var lessonId = R.lesson.id;
        var m = R.meta;
        var isExam = R.mode === 'exam';
        var need = isExam ? (typeof R.lesson.pass === 'number' ? R.lesson.pass : 0.8) : 0;
        var passed = !isExam || score >= need - 1e-9;
        if (R.mode !== 'review' && m) {
            Store.finish(lessonId, score, passed);
            try { if (window.__aeToolComplete) window.__aeToolComplete({ lesson: lessonId, score: pct(score), kind: m.kind, passed: passed ? 1 : 0 }); } catch (_) {}
        } else {
            Store.markDay();
            Store.save();
            ae('course_review_done', { n: R.queue.length, score: pct(score) });
        }
        ae('course_lesson_done', { lesson: lessonId, mode: R.mode, score: pct(score), passed: passed });
        if (R.ctl) { try { R.ctl.destroy && R.ctl.destroy(); } catch (_) {} R.ctl = null; }

        runEl.innerHTML = '';
        var card = el('section', 'lg-card crs-end');
        var ring = el('div', 'crs-ring');
        ring.style.setProperty('--p', pct(score));
        ring.appendChild(el('b', null, R.graded ? pct(score) + '%' : '✓'));
        card.appendChild(ring);
        if (R.graded && passed) card.appendChild(el('div', 'crs-end-stars', stars(score)));
        var titleTx = R.mode === 'review' ? t('review_done')
            : isExam ? (passed ? t('exam_pass') : t('exam_fail'))
            : t('lesson_done');
        card.appendChild(el('h2', 'crs-end-title', titleTx));
        if (R.graded) card.appendChild(el('p', 'crs-end-tx', t('score_line', { right: numFmt(Math.round(R.points * 10) / 10), total: R.graded })));
        if (isExam && !passed) card.appendChild(el('p', 'crs-end-tx', t('exam_need', { pct: pct(need) })));

        if (R.misses.length) {
            card.appendChild(el('p', 'crs-end-tx', t('mistakes_title')));
            var ul = el('ul', 'crs-miss');
            var refs = {};
            R.misses.forEach(function (x) {
                var st = x.step;
                var label = (st.t && (st.t.prompt || st.t.title)) || '';
                var li = el('li');
                li.innerHTML = rich(label) + (x.reveal ? '<br><b>' + esc(t('fb_answer')) + '</b> ' + rich(x.reveal) : '');
                ul.appendChild(li);
                if (st.ref) refs[st.ref] = 1;
            });
            card.appendChild(ul);
            var refList = Object.keys(refs).map(meta).filter(Boolean);
            if (isExam && refList.length) {
                card.appendChild(el('p', 'crs-end-tx', t('exam_review', { list: refList.map(function (r) { return '«' + r.title + '»'; }).join(', ') })));
            }
        }
        if (R.mode !== 'review' && Store.due().length) card.appendChild(el('p', 'crs-end-tx', t('review_hint')));

        var acts = el('div', 'crs-acts');
        acts.style.justifyContent = 'center';
        var next = m ? flat[m.index + 1] : null;
        if (R.mode !== 'review' && isExam && !passed) {
            var again = el('button', 'lg-btn', t('exam_retry')); again.type = 'button';
            again.addEventListener('click', function () { openLesson(lessonId); });
            acts.appendChild(again);
        } else if (next) {
            var nb = el('button', 'lg-btn', canOpen(next) ? t('next_lesson') : '🔒 ' + t('next_lesson')); nb.type = 'button';
            nb.addEventListener('click', function () { openLesson(next.id); });
            acts.appendChild(nb);
        }
        if (R.mode !== 'review' && !(isExam && !passed)) {
            var rep = el('button', 'lg-btn lg-btn-ghost', t('repeat')); rep.type = 'button';
            rep.addEventListener('click', function () { openLesson(lessonId); });
            acts.appendChild(rep);
        }
        var tm = el('button', 'lg-btn lg-btn-ghost', t('to_map')); tm.type = 'button';
        tm.addEventListener('click', showMap);
        acts.appendChild(tm);
        card.appendChild(acts);
        runEl.appendChild(card);
        current = null;
        announce(titleTx);
        focusTop();
        try { acts.querySelector('.lg-btn').focus({ preventScroll: true }); } catch (_) {}
    }

    /* ── рисунки ────────────────────────────────────────────────────── */

    function renderFigure(host, fig, step, api) {
        if (!fig) return null;
        var kind = fig.kind || (fig.svg ? 'svg' : fig.img ? 'img' : fig.emoji ? 'emoji' : null);
        var fn = kind && figures[kind];
        if (!fn) return null;
        var box = el('div', 'crs-fig');
        host.appendChild(box);
        try { fn(box, fig, step, api); } catch (e) { box.remove(); return null; }
        return box;
    }
    figures.svg = function (box, fig, step) {
        box.innerHTML = fig.svg;
        var svg = box.querySelector('svg');
        if (svg) {
            svg.setAttribute('role', 'img');
            var alt = (step && step.t && step.t.figure_alt) || '';
            if (alt) svg.setAttribute('aria-label', alt);
        }
    };
    figures.img = function (box, fig, step) {
        var im = el('img');
        im.src = fig.img;
        im.alt = (step && step.t && step.t.figure_alt) || '';
        im.loading = 'lazy';
        im.decoding = 'async';
        if (fig.w) im.width = fig.w;
        if (fig.h) im.height = fig.h;
        box.appendChild(im);
    };
    figures.emoji = function (box, fig) {
        box.appendChild(el('div', 'crs-fig-emoji', fig.emoji));
    };

    /* ── звук и микрофон ────────────────────────────────────────────── */

    var _ctx = null;
    function audioCtx() {
        var C = window.AudioContext || window.webkitAudioContext;
        if (!C) return Promise.reject(new Error('no_audio'));
        if (!_ctx) _ctx = new C();
        if (window.__liveAudioCtxReady) {
            return window.__liveAudioCtxReady(_ctx).then(function (c) { _ctx = c || _ctx; return _ctx; });
        }
        return (_ctx.state === 'suspended' ? _ctx.resume() : Promise.resolve()).then(function () { return _ctx; });
    }

    var NOTE_IDX = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
    function noteMidi(n) {
        if (typeof n === 'number') return n;
        var m = /^([A-Ga-g])([#b]?)(-?\d)$/.exec(String(n).trim());
        if (!m) return null;
        var v = NOTE_IDX[m[1].toUpperCase()] + (m[2] === '#' ? 1 : m[2] === 'b' ? -1 : 0);
        return v + (parseInt(m[3], 10) + 1) * 12;
    }
    function midiHz(m) { return 440 * Math.pow(2, (m - 69) / 12); }

    function playNotes(notes, o) {
        o = o || {};
        return audioCtx().then(function (ctx) {
            var list = (Array.isArray(notes) ? notes : [notes]).map(noteMidi).filter(function (x) { return x != null; });
            var chord = o.mode === 'chord';
            var dur = o.dur || (chord ? 1.6 : 60 / (o.bpm || 92));
            var t0 = ctx.currentTime + 0.05;
            var out = ctx.createGain();
            out.gain.value = o.gain || 0.22;
            out.connect(ctx.destination);
            var end = t0;
            list.forEach(function (mid, i) {
                var start = chord ? t0 + i * (o.strum || 0) : t0 + i * dur;
                var f = midiHz(mid);
                [1, 2, 3].forEach(function (h, hi) {
                    var osc = ctx.createOscillator();
                    var g = ctx.createGain();
                    osc.type = hi === 0 ? 'triangle' : 'sine';
                    osc.frequency.value = f * h;
                    var peak = hi === 0 ? 1 : hi === 1 ? 0.28 : 0.1;
                    g.gain.setValueAtTime(0.0001, start);
                    g.gain.exponentialRampToValueAtTime(peak, start + 0.012);
                    g.gain.exponentialRampToValueAtTime(0.0001, start + dur * 0.95);
                    osc.connect(g); g.connect(out);
                    osc.start(start); osc.stop(start + dur);
                });
                end = Math.max(end, start + dur);
            });
            return new Promise(function (res) { setTimeout(res, Math.max(0, (end - ctx.currentTime) * 1000)); });
        });
    }

    function speak(text, lang, o) {
        o = o || {};
        return new Promise(function (resolve) {
            var synth = window.speechSynthesis;
            if (!synth || !window.SpeechSynthesisUtterance) { resolve(false); return; }
            try { synth.cancel(); } catch (_) {}
            var u = new SpeechSynthesisUtterance(text);
            u.lang = lang || CFG.locale;
            u.rate = o.rate || 1;
            var voices = [];
            try { voices = synth.getVoices() || []; } catch (_) {}
            var want = String(u.lang).toLowerCase();
            var v = voices.filter(function (x) { return String(x.lang).toLowerCase() === want; })[0]
                || voices.filter(function (x) { return String(x.lang).toLowerCase().indexOf(want.split('-')[0]) === 0; })[0];
            if (v) u.voice = v;
            var done = false;
            function fin(ok) { if (!done) { done = true; resolve(ok); } }
            u.onend = function () { fin(true); };
            u.onerror = function () { fin(false); };
            try { if (window.__speechKeepAlive) window.__speechKeepAlive(u); } catch (_) {}
            try { synth.speak(u); } catch (_) { fin(false); }
            setTimeout(function () { fin(true); }, Math.min(60000, 1500 + String(text).length * 120));
        });
    }

    function openMic(constraints) {
        var c = constraints || { audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } };
        /* Только дверь ядра: на iPhone запрос мимо неё не доходит до аудиосессии
           и отклоняется (IosRecordingOwnsTheAudioSessionTest). */
        if (typeof window.__tmbGum !== 'function') { var e = new Error('no_media'); e.name = 'NotSupportedError'; return Promise.reject(e); }
        try { return Promise.resolve(window.__tmbGum(c)); } catch (err) { return Promise.reject(err); }
    }
    function micError(err) {
        var name = err && (err.name || err.code);
        if (name === 'NotAllowedError' || name === 'SecurityError' || name === 'PermissionDeniedError') return t('mic_denied');
        if (name === 'NotFoundError' || name === 'DevicesNotFoundError' || name === 'OverconstrainedError') return t('mic_none');
        if (name === 'NotSupportedError') return t('mic_unsupported');
        return t('mic_failed');
    }

    /* ── сертификат ─────────────────────────────────────────────────── */

    function loadPdf() {
        if (window.__generatePDF) return Promise.resolve();
        return new Promise(function (res, rej) {
            var s = document.createElement('script');
            s.src = CFG.pdfJs;
            s.async = true;
            var n = document.querySelector('script[nonce]');
            if (n && n.nonce) s.nonce = n.nonce;
            s.onload = function () { res(); };
            s.onerror = function () { rej(new Error('pdf_js')); };
            document.head.appendChild(s);
        });
    }

    function certificate() {
        var input = document.getElementById('crsCertName');
        var name = (input && input.value || '').trim().slice(0, 80);
        if (!name) { if (input) input.focus(); announce(t('cert_need_name')); return; }
        var btn = document.getElementById('crsCertGo');
        if (btn) btn.disabled = true;
        var exams = flat.filter(function (m) { return m.kind === 'exam'; }).length;
        var dateTx;
        try { dateTx = new Intl.DateTimeFormat(window.__intlLocale ? window.__intlLocale() : undefined, { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date()); } catch (_) { dateTx = window.__localYmd ? window.__localYmd(new Date()) : new Date().toLocaleDateString(); }
        var c = el('div');
        c.setAttribute('dir', document.documentElement.getAttribute('dir') || 'ltr');
        c.style.cssText = 'position:fixed;left:-10000px;top:0;width:760px;padding:48px 56px;background:#fffdf7;color:#1c2333;font-family:inherit;border:10px double #c9a646;box-sizing:border-box;text-align:center';
        c.innerHTML =
            '<div style="font-size:14px;letter-spacing:.2em;text-transform:uppercase;color:#8a6d1f;margin-bottom:18px">' + esc(CFG.brand) + '</div>' +
            '<div style="font-size:34px;font-weight:800;margin-bottom:8px">' + esc(t('cert_heading')) + '</div>' +
            '<div style="font-size:16px;color:#4b5565;margin-bottom:26px">' + esc(t('cert_given')) + '</div>' +
            '<div style="font-size:30px;font-weight:700;border-bottom:2px solid #c9a646;display:inline-block;padding:0 24px 6px;margin-bottom:26px">' + esc(name) + '</div>' +
            '<div style="font-size:17px;line-height:1.6;margin-bottom:8px">' + esc(t('cert_body', { course: CFG.title })) + '</div>' +
            '<div style="font-size:15px;color:#4b5565;margin-bottom:30px">' + esc(t('cert_stats', { lessons: flat.length, exams: exams })) + '</div>' +
            '<div style="font-size:14px;color:#4b5565">' + esc(dateTx) + '</div>';
        document.body.appendChild(c);
        loadPdf().then(function () {
            return window.__generatePDF({ element: c, filename: (CFG.slug + '-certificate.pdf'), title: t('cert_heading') });
        }).then(function () {
            ae('course_certificate', {});
        }, function (e) {
            try { if (window.__handleError) window.__handleError(e, 'course_certificate', { say: t('cert_failed') }); } catch (_) {}
        }).then(function () {
            c.remove();
            if (btn) btn.disabled = false;
        });
    }

    /* ── клавиатура ─────────────────────────────────────────────────── */

    function onKey(e) {
        if (!current || runEl.hidden) return;
        if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.altKey) return;
        var owned = false;
        try { owned = window.__keyOwnedByFocus ? window.__keyOwnedByFocus(e) : /^(INPUT|TEXTAREA|SELECT|BUTTON|A)$/.test((document.activeElement || {}).tagName || ''); } catch (_) {}
        if (owned) return;
        if (e.key === 'Enter') {
            var p = current.dom && current.dom.primary;
            if (p && !p.hidden && !p.disabled) { e.preventDefault(); p.click(); }
            return;
        }
        var k = null;
        try { k = window.__keyLetter ? window.__keyLetter(e) : e.key; } catch (_) { k = e.key; }
        if (current.keyFn && k && current.keyFn(String(k).toLowerCase(), e) === true) e.preventDefault();
    }

    /* ── запуск ─────────────────────────────────────────────────────── */

    function boot() {
        root = document.getElementById('crsApp');
        if (!root || !CFG) return;
        mapEl = document.getElementById('crsMap');
        runEl = document.getElementById('crsRun');
        headEl = document.getElementById('crsHead');
        reviewEl = document.getElementById('crsReview');
        certEl = document.getElementById('crsCert');
        liveEl = document.getElementById('crsLive');
        Store.load();
        buildFlat();

        mapEl.addEventListener('click', function (e) {
            var b = e.target && e.target.closest && e.target.closest('.crs-lesson[data-lesson]');
            if (b) openLesson(b.getAttribute('data-lesson'));
        });
        var cont = document.getElementById('crsContinue');
        if (cont) cont.addEventListener('click', onContinue);
        var rv = document.getElementById('crsReviewGo');
        if (rv) rv.addEventListener('click', openReview);
        var cg = document.getElementById('crsCertGo');
        if (cg) cg.addEventListener('click', certificate);
        document.addEventListener('keydown', onKey);
        refreshMap();
        stage('course_map', { done: doneCount(), total: flat.length, premium: CFG.premium ? 1 : 0 });

        try {
            if (window.__earlyAction) {
                window.__earlyAction.claim('course', function (a, btn) {
                    if (a === 'continue') onContinue();
                    else if (a === 'lesson' && btn) openLesson(btn.getAttribute('data-lesson'));
                });
            }
        } catch (_) {}
        try {
            var q = new URLSearchParams(location.search).get('lesson');
            if (q && meta(q)) openLesson(q);
        } catch (_) {}
    }

    function onContinue() {
        var nxt = nextUndone();
        openLesson((nxt || flat[0] || {}).id);
    }

    var CourseKit = {
        step: function (type, impl) { types[type] = impl; },
        figure: function (kind, fn) { figures[kind] = fn; },
        audio: { notes: playNotes, say: speak },
        util: { el: el, rich: rich, richEl: richEl, body: body, shuffle: shuffle, shuffleApart: shuffleApart, fmt: fmt, t: t, tt: tt, noteMidi: noteMidi, midiHz: midiHz, audioCtx: audioCtx, openMic: openMic, micError: micError },
        types: function () { return Object.keys(types); },
        _store: Store
    };
    window.CourseKit = CourseKit;

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else setTimeout(boot, 0);
})();
